import styled from 'styled-components';

export const UnderLineText = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-decoration-line: underline;
  color: #a7a7a7;
  text-align: center;
`;
